<template>
	<div class="content">
		<a-modal title="添加匿名信" :width="700" :visible="subsidyShow" @cancel="subsidyShow = false" @ok="handleOk">
			<a-row>
				<a-col :span="24">
					<div class="item flex justify-start align-center">
						<span>类型：</span>
						<a-radio-group v-model="formData.type" button-style="solid">
							<a-radio-button value="0">建议</a-radio-button>
							<a-divider type="vertical" />
							<a-radio-button value="1">投诉</a-radio-button>
							<a-divider type="vertical" />
							<a-radio-button value="2">检举</a-radio-button>
						</a-radio-group>
					</div>
				</a-col>
				<a-col :span="24">
					<div class="item flex justify-start align-center margin-top">
						<span>标题：</span>
						<a-input v-model="formData.title" placeholder="请输入" class="flex-sub"></a-input>
					</div>
				</a-col>
				<a-col :span="24">
					<div class="item flex justify-start align-start margin-top">
						<span>内容：</span>
						<a-textarea v-model="formData.content" placeholder="请输入" :auto-size="{ minRows: 3, maxRows: 5 }" />
					</div>
				</a-col>
				<a-col :span="24">
					<div class="item text-red flex justify-start margin-top">
						<a-icon type="question-circle" style="margin-top: 5px; margin-right: 10px;" />
						<div>提示：该内容直接反馈到平台总部，公司内部任何人都不可见（公司负责人、区长、主管都看不到）！该反馈记录不做任何留存记录，请放心大胆畅所欲言！</div>
					</div>
				</a-col>
			</a-row>
		</a-modal>
	</div>
</template>

<script>
	import {anonymousLetter} from '@/api/personnel/personnel.js'
	// 新增补助
	export default {
		name: 'CreateForm',
		data() {
			return {
				subsidyShow: false,
				subsidyType: 1,
				usertype: 1,
				value: '',
				formData:{
					type:'',
					title:'',
					content:'',
				}
			}
		},
		methods: {
			// 新增米明鑫
			handleOk(){
				anonymousLetter(this.formData).then(res => {
					if(res.code=='20001'){
						this.$message.success(res.message);
						setTimeout(() => {
							this.handleReset();
							this.$emit('handlleNewData');
						},500)
					}
				})
			},
			handleReset(){
				this.formData={
					type:'',
					title:'',
					content:'',
				}
				this.subsidyShow = false;
			},
			// 打开躺床
			openModal() {
				this.subsidyShow = true
			}
		}
	}
</script>

<style lang="less" scoped>
	.item span {
		display: inline-block;
		width: 50px;
	}

	.ant-radio-button-wrapper {
		border-radius: 0 !important;
	}
</style>